module.exports = __webpack_public_path__ + "static/img/sterownik_systemu.fdbcfc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia_KOPIA/sterownik_systemu.png
// module id = 8j5i
// module chunks = 1